import { Component, HostListener } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Countries } from 'src/app/enums/countries';
import { CustomerType } from 'src/app/enums/customer-type';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-d-company-name',
    templateUrl: './d-company-name.component.html',
    styleUrls: ['./d-company-name.component.scss'],
    standalone: false
})
export class DCompanyNameComponent {
     countriesList: any = [];

     countries = Countries;
     customerType = CustomerType;

     companyInfo!: FormGroup;

     constructor (public generalService: GeneralService,
          public enrollmentService: EnrollmentService
     ) {
          const countries = enrollmentService.getCountries();
          countries.subscribe((v: any) => this.loadCountries(v));
     }

     wizardObj: IWizard = {
          steps: [
               {step:1, text:'Welcome'} as WizardSteps,
               {step:2, text:'Company Information'} as WizardSteps,
               {step:3, text:'User Accounts'} as WizardSteps,
               {step:4, text:'Review'} as WizardSteps,
               {step:5, text:'Contract Documents'} as WizardSteps,
               {step:6, text:'Submit'} as WizardSteps,
               {step:7, text:'Billing Information'} as WizardSteps
          ]
     }

     ngOnInit(): void {
          this.companyInfo = new FormGroup({
               name: new FormControl(this.enrollmentService.newCustomer!.name, [
                    Validators.required,
                    Validators.maxLength(100),
                    Validators.pattern(/^([a-zA-Z0-9 '.,&\$\%-]*)$/) 
               ]),
               country: new FormControl(this.enrollmentService.newCustomer!.country, [
                    Validators.required,
                    Validators.pattern(/^(?!mexico$)/i) 
               ]),
          });  

          setTimeout(() => this.scrollToTop(), 500);
     }
     
     get name() { return this.companyInfo!.get('name'); }
     get country() { return this.companyInfo!.get('country'); }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngAfterViewInit(){
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }

     getTranslator(val: string): string {
          let translation: string = this.generalService.getTranslation(val,'base');
          if (translation === undefined) {
              translation = this.generalService.getTranslation(val,'base');
          }
          return translation;
      }

     loadCountries(value: []) {
          this.countriesList = value;
      }
  
     countryChanged() {
          this.enrollmentService.newCustomer!.address!.zip = '';
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }

     ngOnDestroy(){
          this.enrollmentService.newCustomer!.name = this.companyInfo!.get('name')?.value;
          this.enrollmentService.newCustomer!.country = this.companyInfo!.get('country')?.value;
          const cid = Countries[this.enrollmentService.newCustomer!.country!]
          this.enrollmentService.newCustomer!.address!.countryId = parseInt(cid);
          this.enrollmentService.newCustomer!.address!.country = this.companyInfo!.get('country')?.value;
          this.enrollmentService.saveToLocal();
     }

     @HostListener('window:beforeunload', ['$event'])
     unloadMessage($event: { returnValue: string; }) {
          return $event.returnValue = 'Your changes will not be saved';
     }

     isDisabled() {
          return (this.country!.errors || this.country!.value === 0) || this.companyInfo!.errors ? 'true' : null;
     }
}
